<template>
	<div class="content confirm-policy" v-if="showPage">
		<div class="content-container">
			<div class="section-container-parent w-full">
				<div class="section-container-child">
					<div class="text-lg max-w-prose mx-5 pt-10 pb-10">

						<p class="leading-6 text-gray-700 lg:text-4xl sm:text-3xl text-2xl font-extrabold tracking-wide ">
							<i class="far fa-check-circle text-teal-500"></i> You're Covered!
						</p>


						<div class="relative" :class="{ 'h-72': (loading) }">

							<p class="text-base md:text-lg text-gray-600 mt-5 mb-5">
								Thank you for purchasing cycle insurance through Protectmybike.co.uk. Please find below
								confirmation of your policy with us. You will also receive an email confirmation shortly
								with all your policy documents. Please do read through everything to make sure it all looks
								correct and if you need to make any changes please contact us at <a
									href="mailto:customer@protectmybike.co.uk"
									class="text-teal-500 underline">customer@protectmybike.co.uk</a>.
							</p>

							<div class="sm:mt-8 md:py-10 py-2" v-if="quote">
								<div class="mt-3 sm:mt-8">
									<div class="px-0 md:px-4 py-5 sm:p-0 w-full">
										<div class="grid grid-cols-2">
											<dl class="col-span-2 md:col-span-1">
												<div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
													<dt class="text-base leading-5 text-gray-500">
														Policy Holder
													</dt>
													<dd class="col-span-2 mt-1 text-base leading-5 text-gray-900 sm:mt-0">
														<div>{{ quote.client.name }}</div>
													</dd>
												</div>
												<div class="py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
													<dt class="text-base leading-5 text-gray-500">
														Address
													</dt>
													<dd class="col-span-2 mt-1 text-base leading-5 text-gray-900 sm:mt-0">
														<p class="address_part">{{ (quote.address.house) ?
															quote.address.house : '' }} {{ (quote.address.street) ?
		quote.address.street : '' }}</p>
														<p class="address_part" v-if="quote.address.town">{{
															quote.address.town }}</p>
														<p class="address_part" v-if="quote.address.county">{{
															quote.address.county }}</p>
														<p class="address_part capitalize" v-if="quote.address.postcode">{{
															quote.address.postcode }}</p>
													</dd>
												</div>
												<div class="sm:px-6 py-3 sm:grid sm:grid-cols-3 sm:gap-4">
													<dt class="text-base leading-5 text-gray-500">
														Policy Duration
													</dt>
													<dd
														class="mt-1 text-base leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
														{{ quote.cover_start_human }} <i
															class="text-gray-400 fa fa-long-arrow-right mx-4"></i> {{
																quote.cover_end_human }}
													</dd>
												</div>
												<div class="sm:px-6 py-3 sm:grid sm:grid-cols-3 sm:gap-4">
													<dt class="text-base leading-5 text-gray-500">
														Bikes
													</dt>
													<dd
														class="mt-1 text-base leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
														<ul class="border border-gray-200 rounded-md">
															<li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm leading-5"
																v-for="bike in quote.covered">
																<div class="w-0 flex-1 flex items-center">
																	<i class="fas fa-biking text-lg"></i>
																	<span class="ml-3 flex-1 w-0 truncate">
																		<span class="bike_make capitalize">{{ bike.make
																		}}</span>
																		<span class="divider">-</span>
																		<span class="bike_model capitalize">{{ bike.model
																		}}</span>
																		<span class="divider">-</span>
																		<span class="bike_model capitalize">{{ bike.value |
																			currency }}</span>
																	</span>
																</div>
															</li>
														</ul>
													</dd>
												</div>
											</dl>
											<dl
												class="col-span-2 lg:col-span-1 lg:pt-0 pt-10 md:mt-0 lg:ml-20 ml-0 md:px-0 ">
												<div class="border border-gray-200 text-gray-700 rounded-md shadow-sm">
													<div class="p-3 flex">
														<div class="font-normal">
															Policy Ref
														</div>
														<div class="flex-1 text-right">
															<span class="font-bold">{{ quote.reference }}</span>
														</div>
													</div>
													<div class="p-3 border-t border-gray-200"
														v-if="selectedProducts && Object.keys(selectedProducts).length > 0">
														<div class="flex" v-for="p in selectedProducts">
															<p class="policy-optional">{{ p.name }}</p>
															<p class="policy-price flex-1 text-right">{{
																p.option.value_human }}</p>
														</div>
													</div>

													<div class="p-3 border-t border-gray-200"
														v-if="quote.discounts.length > 0">
														<div class="flex" v-for="discount in quote.discounts">
															<p class="policy-optional">{{ discount.name_human }}</p>
															<p class="policy-price flex-1 text-right">- {{ discount.value }}
															</p>
														</div>
													</div>
													<div
														class="p-3 flex justify-between sm:gap-4 font-medium border-t border-gray-200">
														<div>
															<span v-if="quote.subscription_type == 'annually'">
																Total Premium Paid
															</span>
															<span v-else>Monthly Premium to be paid</span>
															<span class="text-xs block">(inc IPT at 12%)</span>
														</div>
														<div class="mt-1 sm:mt-0">
															<span v-if="quote.subscription_type == 'annually'">
																{{ quote.client_premium | currency }}
															</span>
															<span v-else>
																{{ (quote.client_premium / 12) | currency }}
															</span>
														</div>
													</div>
												</div>
											</dl>
										</div>
									</div>
								</div>

								<div class="policy-documents md:mt-20 mt-6 bg-white">
									<h3 class="text-2xl font-bold mb-4 mt-3 text-gray-700">Policy Documents</h3>

									<div class="px-0 ">

										<div class="documents">
											<div class="document-link  border border-gray-200 rounded-md shadow-sm placeholder-link"
												v-if="policy === null || policy.documents.length === 0">
												<a class="text-teal-500 no-underline cursor-not-allowed">
													<div class="icon relative">
														<div class="w-12">
															<loading :show="true" message="Loading..." variant="mini">
															</loading>
														</div>
													</div>
													<div class="doc-text font-medium">
														<span>Policy Schedule</span>
													</div>
												</a>
											</div>

											<div class="document-link  border border-gray-200 rounded-md shadow-sm"
												v-for="doc in policyDocuments">
												<a @click="documentDownload(doc)"
													class="text-teal-500 no-underline cursor-pointer">
													<div class="icon">
														<i class="far fa-file-pdf"></i>
													</div>
													<div class="doc-text font-medium">
														<span>{{ doc.alias }}</span>
													</div>
												</a>
											</div>
											<div class="document-link  border border-gray-200 rounded-md shadow-sm"
												v-for="doc in quoteDocuments">
												<a :href="doc.url" target="blank"
													class="text-teal-500 no-underline cursor-pointer">
													<div class="icon">
														<i class="far fa-file-pdf"></i>
													</div>
													<div class="doc-text font-medium">
														<span>{{ doc.alias }}</span>
													</div>
												</a>
											</div>
										</div>
									</div>
								</div>


								<div v-if="competitions?.insurance_choice_awards?.enabled === true"
									class="md:mt-20 mt-6 bg-white rounded-md shadow-lg overflow-hidden">
									<a :href="competitions.insurance_choice_awards.url" target="_blank">
										<img :src="competitions.insurance_choice_awards.images.banner" class="w-full" alt="" />
									</a>
								</div>
								


							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'quote.policy',
	props: {
		// quote: {
		// 	required: true,
		// },
		// loading: {
		// 	type: Boolean,
		// 	default: false,
		// },
	},
	data() {
		return {
			quote: null,
			policy: null,
			loading: false,
			isLoading: true,
			errors: false,
			timer: null,
			showPage: false,
			competition: null,
		}
	},
	computed: {
		policyDocuments() {
			return this.policy ? this.policy.documents : [];
		},
		quoteDocuments() {
			return this.quote ? this.quote.documents : [];
		},
		selectedProducts() {
			var products = {};

			const self = this;


			Object.keys(self.quote.products.products).forEach(function (key) {
				let productData = self.quote.products.products[key].meta;

				// get selected product
				let options = self.quote.products.products[key].options;
				let selected = options.filter(option => option.is_selected == true);
				// if(productData.is_selectable) {
				if (selected[0].value > 0) {
					products[key] = productData;
					products[key].option = selected[0];
				}
				// }
			});

			return products;
		},
		unselectableProducts() {
			var products = {};

			const self = this;
			Object.keys(self.quote.products.products).forEach(function (key) {
				let productData = self.quote.products.products[key].meta;

				// get selected product (if selectable by user)
				if (!productData.is_selectable) {
					products[key] = productData;

					let options = self.quote.products.products[key].options;
					let selected = options.filter(option => option.is_selected == true);
					products[key].option = selected[0];
				}
			});

			return products;
		},
		numSelected() {
			return Object.keys(this.selectedProducts).length;
		},
		hasSelectableProducts() {
			let hasProducts = false;

			if (this.selectableProducts) {
				Object.keys(this.selectableProducts).forEach((prod_key) => {
					if (this.selectableProducts[prod_key].option) {
						hasProducts = true;
					}
				});
			}

			return hasProducts;
		},
		selectableProducts() {
			var products = {};

			const self = this;
			Object.keys(self.policy.products.products).forEach(function (key) {
				if (self.policy.products.products[key].meta.is_selectable) {
					products[key] = self.policy.products.products[key].meta;

					// get selected product
					let options = self.policy.products.products[key].options;
					let selected = options.filter(option => option.is_selected == true);
					products[key].option = selected[0];
				}
			});

			return products;
		},
	},
	watch: {
		// loading: function (newLoading, oldLoading) {
		// 	this.isLoading = newLoading;
		// },
	},
	mounted() {

		this.getQuote();
		this.getPolicy();
		this.getCompetitions();

		const self = this;
		let count = 0
		this.timer = setInterval(function () {
			count++;
			if (count > 10 || (self.policy && self.policy.documents && self.policy.documents.length > 0)) {
				clearInterval(this.timer);
			}
			self.getPolicy(false);
		}, 5000);
	},
	methods: {
		getQuote() {
			Vue.axios.get('quote/getQuote')
				.then((resp) => {

					if (resp.data) {
						if (!resp.data.success) {
							this.quote = null;

							if (!this.quote) {
								// window.location.replace("/");
							}
						} else {
							this.quote = resp.data.quote;

							// if(resp.data.quote.policy_id && resp.data.quote.status == 'sale') {
							// 	if(this.$route.name !== 'quote.confirm') {
							// 		this.$router.push({name: 'quote.confirm' });
							// 	}
							// }
						}
					} else {

						this.feedback.push({
							'type': 'error',
							'message': 'An error occurred - Quote couldn\'t be found'
						});
					}
				})
				.catch(error => {
					// show feedback
					self.feedback.push({
						'type': 'error',
						'message': error
					});
				});
		},
		getPolicy(showLoading = true) {

			const self = this;

			Vue.axios.get('policy/get')
				.then(response => {
					this.loader = false;
					this.showPage = true;

					if (response.data) {

						if (response.data.success) {
							self.policy = response.data.policy;

							self.$emit('price', self.policy.client_premium);
						} else {

						}
					}
				})
				.catch(error => {
					// show feedback
					// self.$emit('feedback', {
					// 	'type': 'error',
					// 	'message': error
					// });
					this.showPage = true;

					if (error.response && error.response.status == 403 && error.response.data.hasOwnProperty('code')) {
						if (error.response.data.code == 'no_session_for_policy' && this.quote.status != 'sale') {
							this.$emit('hide-footer', true);
							this.$emit('paymentLoading', false);

							this.showPage = false;
							if (this.timer) {
								clearInterval(this.timer);
							}
							this.$nextTick(() => {
								window.location.replace("/quote/payment");
							});
						}
					}

				});
		},
		documentDownload(file) {
			const self = this;

			axios.get('quote/document/download/' + file.id, { responseType: 'blob' })
				.then((resp) => {
					var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
					var fileLink = document.createElement('a');


					fileLink.href = fileURL;
					fileLink.setAttribute('download', file.alias + '.pdf');
					document.body.appendChild(fileLink);

					fileLink.click();

					self.isDownloading = false;
				});
		},
		copyCode() {
			var el = this.$refs.mycode;
			el.select();
			el.setSelectionRange(0, 99999);
			document.execCommand("copy");


		},
		getCompetitions() {
			Vue.axios.get('competitions')
				.then(response => {
					this.competitions = response.data;
				});
		},
	}
}
</script>